import { configureStore } from '@reduxjs/toolkit';
import contentReducer from './slices/contentSlice';
import solutionsReducer from './slices/solutionsSlice';
import agentsReducer from './slices/agentsSlice';
import { localStorageMiddleware } from './middleware/localStorageMiddleware';

export const store = configureStore({
  reducer: {
    content: contentReducer,
    solutions: solutionsReducer,
    agents: agentsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(localStorageMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
